import React from 'react';
import s from '../../s.module.less';

export default function OptLabel({ children }: { children: React.ReactNode }) {
    return (
        <>
            {children} <span className={s.optional}>(optional)</span>
        </>
    );
}
